export default __webpack_public_path__ + "static/media/android-s4-cn.ced304c6.webp";